import React from "react";

const About = ({ user }) => {
  return (
    <div className="bg-white p-6 shadow-md rounded-lg w-4/5 max-w-3xl mx-auto">
      <h2 className="text-xl font-semibold mb-4">À propos de moi</h2>
      <p><strong>Nom complet :</strong> {user.firstName} {user.lastName}</p>
      <p><strong>Family ID:</strong> {user.familyId || "N/A"}</p>
    </div>
  );
};

export default About;